import { Machine } from '@bleckert/state';
import agent from 'local/test/agent';
import { data } from 'local/test/data';
import states from 'local/test/states';
import { route } from 'local/test/events/router';
import actions from 'local/test/actions';

export const machine = new Machine(states, 'IDLE', data, actions);

agent.onMessage((e) => {
	route(machine, e, (m, { event, args }) => {
		machine.dispatch(event, args);
	});
});
